
import { Calendar, Shield, Zap, Star } from 'lucide-react';
import { motion } from 'framer-motion';

const USPSection = () => {
  const usps = [
    {
      icon: <Calendar className="h-12 w-12 text-chrona-accent" />,
      title: "Schnell buchen",
      description: "In weniger als einer Minute zum perfekten Termin"
    },
    {
      icon: <Shield className="h-12 w-12 text-chrona-accent" />,
      title: "DSGVO-sicher",
      description: "Deine Daten werden sicher und vertraulich behandelt"
    },
    {
      icon: <Zap className="h-12 w-12 text-chrona-accent" />,
      title: "Ready in 3 Klicks",
      description: "Intuitiv, schnell und ohne unnötigen Aufwand"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-[#1a1a1a] to-[#212121] relative">
      {/* Subtle background elements with improved transitions */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/2 w-[600px] h-[600px] -translate-x-1/2 bg-chrona-accent/5 rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <motion.h2 
            initial={{ opacity: 0, y: 10 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl font-bold mb-4 text-[#F8F8F8]"
          >
            Warum CHRONA?
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 10 }} 
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
            className="text-xl text-[#F8F8F8]/80 max-w-2xl mx-auto"
          >
            Wir machen Terminbuchungen so einfach und komfortabel wie nie zuvor
          </motion.p>
        </motion.div>

        {/* Featured testimonial with improved contrast */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          viewport={{ once: true }}
          className="max-w-3xl mx-auto mb-16 bg-[#191919]/60 backdrop-blur-md p-6 rounded-2xl relative overflow-hidden border border-[#F8F8F8]/10 shadow-lg"
        >
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-chrona-accent via-chrona-accent-light to-[#212121]"></div>
          <div className="flex flex-col md:flex-row gap-6 items-center">
            <div className="md:w-1/4">
              <div className="w-24 h-24 rounded-full overflow-hidden border-2 border-chrona-accent">
                <img 
                  src="/lovable-uploads/e799ff9c-7b31-416f-b81e-593b801b4509.png" 
                  alt="Studio Testimonial" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="md:w-3/4">
              <div className="flex items-center mb-2">
                {[1, 2, 3, 4, 5].map((star) => (
                  <Star key={star} className="h-4 w-4 fill-chrona-accent text-chrona-accent" />
                ))}
              </div>
              <blockquote className="text-lg mb-4 italic text-[#F8F8F8]">
                "CHRONA hat unsere Terminbuchungen revolutioniert. Unsere Kunden lieben die einfache Nutzung und wir sparen täglich wertvolle Zeit."
              </blockquote>
              <div className="text-right">
                <p className="font-medium text-chrona-accent">Sarah Müller</p>
                <p className="text-sm text-[#F8F8F8]/70">Inhaberin, Beauty Studio Berlin</p>
              </div>
            </div>
          </div>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {usps.map((usp, index) => (
            <motion.div 
              key={usp.title} 
              className="bg-[#191919]/40 backdrop-blur-md p-8 rounded-2xl flex flex-col items-center text-center transform transition-all duration-300 hover:scale-105 hover:shadow-lg border border-[#F8F8F8]/10 hover:border-chrona-accent/20"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
            >
              <div className="mb-6 p-4 rounded-full bg-gradient-to-br from-chrona-accent/20 to-chrona-accent/10 shadow-inner">
                {usp.icon}
              </div>
              <h3 className="text-xl font-semibold mb-3 text-[#F8F8F8]">{usp.title}</h3>
              <p className="text-[#F8F8F8]/80">{usp.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default USPSection;
